import Nora from '@openng/optimus-ui-themes/nora';
import { definePreset } from '@openng/optimus-ui-themes';

// IMO Lara and Nora provide the best theme presets for us, leaving this as Nora for now
// but this is easy to change later on
export const CrlincTheme = definePreset(Nora, {
  primitive: {
    green: {
      50: '#bff75e',
      100: '#b4e85a',
      200: '#a2d152',
      300: '#93bd4b',
      400: '#87ad45',
      500: '#799b3e',
      600: '#6b8a36',
      700: '#5b752e',
      800: '#4b6126',
      900: '#3d4f1f',
      950: '#2b3815',
    },
  },
  semantic: {
    primary: {
      50: '{green.50}',
      100: '{green.100}',
      200: '{green.200}',
      300: '{green.300}',
      400: '{green.400}',
      500: '{green.500}',
      600: '{green.600}',
      700: '{green.700}',
      800: '{green.800}',
      900: '{green.900}',
      950: '{green.950}',
    },
  },
  components: {
    tabs: {
      tab: {
        margin: '0 2px 0 0',
        borderColor: '{green.500}',
        borderWidth: '2px',
        hoverBorderColor: '{green.500}',
      },
      tabpanel: {
        padding: '0 5px 0',
      },
    },
  },
});
